import { SVGProps } from "react";

export const WLDIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 600"
    {...props}
  >
    <circle cx="300" cy="300" r="270" fill="none" stroke="#000000" strokeWidth="35" />
    <path
      fill="none"
      stroke="#000000"
      strokeWidth="35"
      strokeLinecap="round"
      d="M258.5,217.3c0,0-145.5,0.2-145.5,0.2c-48.2,0-87.2,39.1-87.2,87.2c0,48.2,39.1,87.2,87.2,87.2h140.1"
    />
    <line
      x1="118"
      y1="330"
      x2="454"
      y2="330"
      stroke="#000000"
      strokeWidth="35"
      strokeLinecap="round"
    />
  </svg>
);
